import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "pt-20" };
const _hoisted_2 = { class: "flex flex-col items-center justify-center mt-12 sm:items-stretch sm:mt-20 sm:flex-row" };
const _hoisted_3 = { class: "flex flex-col items-center" };
const _hoisted_4 = { class: "self-start text-xs text-primary-900 dark:text-primary-200" };
const _hoisted_5 = { class: "mx-auto mt-16 border-t border-gray-200 dark:border-gray-700 w-112" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.profile.user_profile')
};
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { uploadImage } from '@/composables/images';
import NeedHelp from '@/components/NeedHelp.vue';
import SectionHeading from '@/components/base/headings/SectionHeading.vue';
import Supports from '@/components/image_uploads/Supports.vue';
import UploadImageButton from '@/components/image_uploads/UploadImageButton.vue';
import UserProfileForm from '@/components/UserProfileForm.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'UserProfile',
    setup(__props) {
        const store = useStore();
        const uploadLoading = ref(false);
        const uploadError = ref(false);
        const logout = () => {
            store.dispatch('logout');
        };
        const session = computed(() => store.getters.session);
        const handleUpload = async (image) => {
            uploadLoading.value = true;
            uploadError.value = false;
            const result = await uploadImage(image, (file) => store.dispatch('updateUserAvatar', file));
            if (!result) {
                uploadError.value = true;
            }
            uploadLoading.value = false;
        };
        return (_ctx, _cache) => {
            const _component_avatar = _resolveComponent("avatar");
            const _component_pill_button = _resolveComponent("pill-button");
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createVNode(SectionHeading, {
                    heading: _ctx.$t('profile')
                }, null, 8, ["heading"]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('avatar')), 1),
                        _createVNode(_component_avatar, {
                            class: "mt-8",
                            size: "xl",
                            disconnected: false,
                            "error-border": uploadError.value,
                            "show-tooltip": false,
                            user: _unref(session)
                        }, null, 8, ["error-border", "user"]),
                        _createVNode(UploadImageButton, {
                            class: "mt-4",
                            loading: uploadLoading.value,
                            onUpload: handleUpload
                        }, null, 8, ["loading"]),
                        _createVNode(Supports, {
                            class: "mt-2",
                            error: uploadError.value
                        }, null, 8, ["error"])
                    ]),
                    _createVNode(UserProfileForm, {
                        ref: "form",
                        class: "w-5/6 sm:ml-12 sm:w-71"
                    }, null, 512)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_pill_button, {
                        class: "mx-auto mt-10 max-w-40 sm:-mx-5",
                        kind: "secondary",
                        onClick: logout
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('sign_out')), 1)
                        ], undefined, true),
                        _: 1
                    })
                ]),
                _createVNode(NeedHelp, { class: "mt-4" })
            ]));
        };
    }
});
